import { motion } from "framer-motion";
import { BarChart3, Users, Calendar, PieChart, Shield, Link as LinkIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

export function ResultsTabs({ activeTab, setActiveTab, consulta, results }) {
  const { t } = useTranslation();
  const tabs = [
    { id: 'general', icon: BarChart3, label: t('results.general') },
    ...(consulta?.enable_stats_sex !== false ? [{ id: 'sex', icon: Users, label: t('results.bySex') }] : []),
    ...(consulta?.enable_stats_age !== false ? [{ id: 'age', icon: Calendar, label: t('results.byAge') }] : []),
    { id: 'summary', icon: PieChart, label: t('results.votingSummary') },
    { id: 'participation', icon: Users, label: t('results.participation') },
    ...(consulta?.enable_vot_ma_alcada ? [{ id: 'audit', icon: Shield, label: t('results.handVoteTab') }] : []),
    ...(consulta?.enable_audit ? [{ id: 'audit_verify', icon: Shield, label: t('results.auditTab') }] : []),
    ...(results?.blockchain_enabled ? [{ id: 'blockchain', icon: LinkIcon, label: t('results.blockchainTab') }] : [])
  ];

  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.15 }}
      className="flex gap-2 mb-6 border-b border-slate-200 overflow-x-auto">
      {tabs.map(tab => (
        <button
          key={tab.id}
          onClick={() => setActiveTab(tab.id)}
          data-testid={`tab-${tab.id}`}
          className={`px-4 py-2 font-medium transition-colors border-b-2 -mb-px whitespace-nowrap ${
            activeTab === tab.id
              ? 'border-blue-600 text-blue-600'
              : 'border-transparent text-slate-500 hover:text-slate-700'
          }`}
        >
          <tab.icon className="h-4 w-4 inline mr-2" />
          {tab.label}
        </button>
      ))}
    </motion.div>
  );
}
